import React from 'react';
import { ColumnH1 } from 'lib/components/Typography';

type TabHeaderProps = {
  title: string;
  children?: React.ReactNode;
};

export function TabHeader({ title, children }: TabHeaderProps) {
  return (
    <div className="flex justify-between items-center p-6 border-b border-column-gray-100">
      <ColumnH1>{title}</ColumnH1>
      <div className="flex items-center gap-4">{children}</div>
    </div>
  );
}
